import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetUserWebNotificationsQueryResponse, GetUserWebNotificationsQueryParams, GetUserWebNotifications400, GetUserWebNotifications500 } from "../types/GetUserWebNotifications";

export const getUserWebNotificationsQueryKey = (params?: GetUserWebNotificationsQueryParams) =>     [{url:`/api/lk/notifications`},...(params ? [params] : [])] as const;
      export function getUserWebNotificationsQueryOptions <TData = GetUserWebNotificationsQueryResponse, TError = GetUserWebNotifications400 | GetUserWebNotifications500>(params?: GetUserWebNotificationsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getUserWebNotificationsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/lk/notifications`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получить web нотификации
 * @link /api/lk/notifications
 */

export function useGetUserWebNotifications <TData = GetUserWebNotificationsQueryResponse, TError = GetUserWebNotifications400 | GetUserWebNotifications500>(params?: GetUserWebNotificationsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getUserWebNotificationsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getUserWebNotificationsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
